import {createContext, MutableRefObject} from 'react';

export type RecoveryFlush = () => Promise<void>;

export type RecoveryFlushRef = MutableRefObject<RecoveryFlush | null>;

interface SessionRecovery {
  onUnauthorized(): void;
  recoveryFlushRef: RecoveryFlushRef;
}

const SessionRecoveryContext = createContext<SessionRecovery>({
  onUnauthorized: () => undefined,
  recoveryFlushRef: {current: null},
});

export default SessionRecoveryContext;
